import { AllPdQaqcResponse, PdQaqcResponse } from '@gtpl/shared-models/production-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { PeelingDto } from './dto/peeling.dto';
import { PeelingService } from './peeling.service';
import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Req } from '@nestjs/common';
import { PeelingIdRequest } from './dto/peeling-id-request';
import { CommonResponse } from '@gtpl/shared-models/masters';

@ApiTags('peeling')
@Controller('peeling')
export class PeelingController {
    constructor(
        private service : PeelingService,
        private  readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){ }

    @Post('/createPeeling')
    async createPeeling(@Body() dto: PeelingDto, isUpdate: boolean = false): Promise<PdQaqcResponse> {
        try {
            return await this.service.createPeeling(dto, false);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(PdQaqcResponse, error);
        }
    }
    @Post('/updatePeeling')
    async updatePeeling(@Body() dto: PeelingDto, @Req() request: Request): Promise<PdQaqcResponse> {
        try {
            return await this.service.createPeeling(dto, true);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(PdQaqcResponse, error);
        }
    }
    @Post('/getAllPeelings')
    async getAllPeelings(): Promise<AllPdQaqcResponse> {
        try {
            return await this.service.getAllPeelings();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllPdQaqcResponse, error);
        }
    }
    @Post('/getAllActivePeelings')
    async getAllActivePeelings(@Req() request: Request): Promise<AllPdQaqcResponse> {
        try {
            return await this.service.getAllActivePeelings();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllPdQaqcResponse, error);
        }
    }
    @Post('/activateOrDeactivatePeeling')
    async activateOrDeactivatePeeling(@Body() qReq: PeelingIdRequest): Promise<PdQaqcResponse> {
        try {
            return await this.service.activateOrDeactivatePeeling(qReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(PdQaqcResponse, error);
        }
    }
    @Post('/createPeelingInfo')
    async createPeelingInfo(@Body() PeelingInfo: PeelingDto): Promise<CommonResponse> {
        try {
            return await this.service.createPeelingInfo(PeelingInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAllPeelingSamplesForSamplesId')
    async getAllPeelingSamplesForSamplesId(@Body() qReq: PeelingIdRequest): Promise<PdQaqcResponse> {
        try {
            return await this.service.getAllPeelingSamplesForSamplesId(qReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(PdQaqcResponse, error);
        }
    }
   


}
